// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ColumnExtended } from '../../../assets/icons/extended/entities/column.svg?react';
import { createIcons } from '../../Icon';
const ColumnIcon = /* @__PURE__ */ createIcons('Column', {
    extended: ColumnExtended
});
ColumnIcon.supportedTypes = ['extended'];
ColumnIcon.category = 'entities';
export default ColumnIcon;
